export class LodeStarFeeTypePricingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes({ feeTypeId }) {
    return this.#http.get(`api/lodestar-fee-types/${feeTypeId}`);
  }

  async createType({ feeTypeId, ...body }) {
    return this.#http.post(`api/lodestar-fee-types/${feeTypeId}`, body);
  }

  async editType({ lodeStarFeeTypeId, ...body }) {
    return this.#http.put(`api/lodestar-fee-types/${lodeStarFeeTypeId}`, body);
  }

  async deleteType({ lodeStarFeeTypeId }) {
    return this.#http.delete(`/api/lodestar-fee-types/${lodeStarFeeTypeId}`);
  }
}
